export default "__VITE_ASSET__DKHufBof__"